<template>
  <div>
    <b-row>
      <b-col>
        <h4>Sản phẩm con</h4>
      </b-col>
      <b-col>
        <div class="justify-content-end" style="text-align: end">
          <div class="mb-5">
            <span
              v-show="checkPermission('PRODUCT_INSERT')"
              v-b-tooltip.hover
              :title="isCreateProductBlocked ? createProductBlockedTooltip : ''"
              class="d-inline-block"
            >
              <b-button
                class="btn btn-primary font-weight-bolder btn-sm button"
                :disabled="isCreateProductBlocked"
                @click="onAddProduct"
              >
                <i style="font-size: 1rem" class="flaticon2-add-1"></i>Thêm mới
              </b-button>
            </span>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-table
      :items="products"
      :fields="fields"
      class="table-bordered table-hover col-md-12"
    >
      <template v-slot:cell(count)="row">
        <div class="d-flex justify-content-center">
          <span v-text="row.item.count"></span>
        </div>
      </template>

      <template v-slot:cell(status)="row" style="width: 1%">
        <span
          v-text="checkStatus(row.item.status)"
          class="label font-weight-bold label-lg label-inline"
          v-bind:class="{
            'label-light-warning': row.item.status === 1,
            'label-light-success': row.item.status === 2,
            'label-light-danger': row.item.status === 3,
            'label-light-default': row.item.status === 4,
          }"
        ></span>
      </template>

      <template v-slot:cell(originalPrice)="row">
        <div style="text-align: end">
          <span v-text="convertPrice(row.item.originalPrice)"></span>
        </div>
      </template>

      <template v-slot:cell(sellingPrice)="row">
        <div style="text-align: end">
          <span v-text="convertPrice(row.item.sellingPrice)"></span>
        </div>
      </template>

      <template v-slot:cell(totalQualityInstock)="row">
        <div style="text-align: center">
          <span v-text="row.item.totalQualityInstock"></span>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <v-icon
            small
            class="mr-2 text-primary"
            @click="$emit('edit-product', row.item)"
            v-b-tooltip
            title="Cập nhật"
            >mdi-pencil</v-icon
          >
          <v-icon
            small
            class="mr-2 text-danger"
            @click="$emit('delete-product', row.item)"
            v-b-tooltip
            title="Xóa"
            >mdi-delete</v-icon
          >
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { convertPrice } from '@/utils/common';
import companyCatalogFlagsMixin from '@/view/mixins/companyCatalogFlags.mixin';

export default {
  name: 'ChildProductsTable',
  mixins: [companyCatalogFlagsMixin],
  props: {
    products: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      required: true,
    },
    checkPermission: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onAddProduct() {
      if (!this.ensureCanCreateProduct()) {
        return;
      }
      this.$emit('add-product');
    },
    convertPrice,
    checkStatus(status) {
      const statusMap = {
        1: 'Mới',
        2: 'Đang bán',
        3: 'Ngừng bán',
        4: 'Hết hàng',
      };
      return statusMap[status] || '';
    },
  },
};
</script>
